export default {
    breadcrumbs: {
        members: 'Members In Your Area',
    },
    heading:
        'There are no members in your geographic area | There is 1 member in your geographic area | There are {count} members in your geographic area',
}
